import { ShaderMaterial, TextureLoader, Vector3 } from "three";
import glslify from 'glslify';

import bgVert from "../glsl/bg.vert";
import brush from "../glsl/brush.frag";


export class MyShaderMat{

    public mat:THREE.ShaderMaterial;

    constructor(){

        let tex = new TextureLoader().load("./grade2.png");

        this.mat = 
            new ShaderMaterial({
                uniforms: {
                    //time: {value: 1.0},
                    tex1:{value:tex},
                    col1:{value:new Vector3(1.0,0)}
                    //flowMap:{value:null},
                    //dLight:{value:Params.dLight.position},
                    //resolution: {value: new THREE.Vector2()}
                },
                vertexShader:   (bgVert),
                fragmentShader: glslify(brush)
            });

    }

    public updateColor(rr:number,gg:number,bb:number){

        if(this.mat){
            this.mat.uniforms.col1.value.x = rr;
            this.mat.uniforms.col1.value.y = gg;
            this.mat.uniforms.col1.value.z = bb;    
        }

    }

}